import React, { useState } from "react";
import { Button, Input, Modal, message } from "antd";
import MondayButton from "../../../../commonComponents/MondayButton/MondayButton";
import { CheckOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { API } from "../../../../../helpers/API/amplifyApi";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";

const IP_WHITELIST_FIELD_ID = "4fgtf65fgf-mnjlsdfv-89000nmnbhujj";

function CreateNewIp({
  tableData,
  setTableData,
  gridApi,
  programFields,
  setProgramFields,
  username,
  visible,
  setVisible,
}) {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [data, setData] = useState({});

  const onChange = (obj) => setData((prev = {}) => ({ ...prev, ...obj }));

  const checkExisting = (val) => {
    let temp = [...tableData];
    let result = temp.filter((item) => item.value === val);
    return result.length > 0 ? true : false;
  };

  const handleOk = async () => {
    try {
      if (data.ip !== "" && !checkExisting(data.ip)) {
        const logs = [...(programFields.fieldOptions?.logs || [])];
        logs.push({
          id: uuidv4(),
          activity: "U Shtua",
          author: username,
          changeDate: Date.now(),
          currentData: data.ip,
        });

        const newWhiteList = [...tableData, data];

        await API.put(
          "programFields",
          `/programFields/${IP_WHITELIST_FIELD_ID}`,
          { body: { fieldOptions: { whiteList: newWhiteList, logs: logs } } }
        ).then(() => {
          setTableData((prev) => [...prev, data]);
          setProgramFields((prev) => ({
            ...prev,
            fieldOptions: { whiteList: newWhiteList, logs: logs },
          }));
          Swal.fire({
            title: "Sukses",
            text: "Ip Adresa u shtua me sukses",
            customClass: {
              popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
            },
            icon: "success",
          });
        });
      } else {
        message.error("Ip Adresa eshte e zene ose jo e sakte");
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleCleanUp();
    }
  };

  const handleCleanUp = () => {
    setVisible(false);
    setData({});
  };
  return (
    <Modal
      title="Krijo nje konfigurim tjeter"
      open={visible}
      className={
        isDarkMode
          ? "dark createNewIpModal darkHeader"
          : "createNewIpModal lightHeader"
      }
      // onOk={handleOk}
      onCancel={handleCleanUp}
      footer={null}
      centered
    >
      <Input
        placeholder="Ip Adresa"
        value={data.ipAddress}
        onChange={(e) => onChange({ ip: e.target.value })}
      />
      <Input
        placeholder="Lloji i IP Adreses"
        value={data.type}
        onChange={(e) => onChange({ type: e.target.value })}
      />
      <Input
        placeholder="Përshkrimi"
        value={data.description}
        onChange={(e) => onChange({ description: e.target.value })}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <MondayButton
          className="mondayButtonGreen"
          Icon={<CheckOutlined />}
          onClick={handleOk}
        >
          Shto IP te lejuar
        </MondayButton>
      </div>
    </Modal>
  );
}

export default CreateNewIp;
